import React, { useEffect, useState } from 'react';
import { Form, Select, DatePicker, Checkbox, Row, Col, Switch } from 'antd';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';

const { RangePicker } = DatePicker;

interface ReportFiltersProps {
  reportKey: string;
  form: any;
  filterOptions: {
    division_options?: { label: string; value: string }[];
    departmentOptions?: { label: string; value: string }[];
    department_type_options?: { label: string; value: string }[];
    type_options?: { label: string; value: string }[];
    lab_service_type_options?: { label: string; value: string }[];
    lab_service_category_options?: { label: string; value: string }[];
    lab_sample_options?: { label: string; value: string }[];
    invoice_status_option?: { label: string; value: string }[];
    date_related_to_option?: { label: string; value: string }[];
    lab_count_by_options?: { label: string; value: string }[];
    pr_category_options?: { label: string; value: string }[];
    parent_pr_category_options?: { label: string; value: string }[];
    product_category_options?: { label: string; value: string }[];
    import_types_options?: { label: string; value: string }[];
    export_types_options?: { label: string; value: string }[];
    level_options?: { label: string; value: string }[];
    payment_method_options?: { label: string; value: string }[];
    cashier_options?: { label: string; value: string }[];
    cashier_location_options?: { label: string; value: string }[];
  };
}

const ReportFilters: React.FC<ReportFiltersProps> = ({ reportKey, form, filterOptions }) => {
  const colSpan = 12;

  const commonDateRange = (
    <Col span={colSpan}>
      <Form.Item name="dateRange" label="Date Range" labelCol={{ span: 24 }}>
        <RangePicker style={{ width: '100%' }} />
      </Form.Item>
    </Col>
  );

  // const renderCheckboxRow = () => (
  //   <Row gutter={[16, 16]}>
  //     <Col span={24}>
  //       <Form.Item name="includeNominal" valuePropName="checked">
  //         <Checkbox>Include Nominal?</Checkbox>
  //       </Form.Item>
  //     </Col>
  //   </Row>
  // );

  const renderFilters = () => {
    switch (reportKey) {
      case 'earnings-by-divisions':
        return (
          <>
            <Row gutter={[16, 16]}>
              <Form.Item name="model" hidden initialValue="LR">
                <BaseInput />
              </Form.Item>
              <Col span={colSpan}>
                <Form.Item name="division_ids" label="Division" labelCol={{ span: 24 }}>
                  <Select
                    mode="multiple"
                    options={filterOptions.division_options}
                    placeholder="Select Division"
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    dropdownStyle={{ maxHeight: 8 * 32 }}
                    style={{ width: '100%' }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                  />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="types" label="Process" labelCol={{ span: 24 }}>
                  <Select mode="multiple" options={filterOptions.type_options} placeholder="Select Process" />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="lab_service_category_ids" label="Service Category/Test" labelCol={{ span: 24 }}>
                  <Select
                    mode="multiple"
                    options={filterOptions.lab_service_category_options}
                    placeholder="Select Category"
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    dropdownStyle={{ maxHeight: 8 * 32 }}
                    style={{ width: '100%' }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                  />
                </Form.Item>
              </Col>

              <Col span={colSpan}>
                <Form.Item name="lab_service_type" label="Service Type" labelCol={{ span: 24 }}>
                  <Select options={filterOptions.lab_service_type_options} placeholder="Select Type" />
                </Form.Item>
              </Col>
              {commonDateRange}
              <Col span={colSpan}>
                <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                  <Select options={filterOptions.invoice_status_option} />
                </Form.Item>
              </Col>
            </Row>
            {/* {renderCheckboxRow()} */}
          </>
        );

      case 'test-count-by-divisions':
        return (
          <>
            <Row gutter={[16, 16]}>
              <Form.Item name="model" hidden initialValue="LR">
                <BaseInput />
              </Form.Item>
              <Col span={colSpan}>
                <Form.Item name="division_ids" label="Division" labelCol={{ span: 24 }}>
                  <Select
                    mode="multiple"
                    options={filterOptions.division_options}
                    placeholder="Select Division"
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    dropdownStyle={{ maxHeight: 8 * 32 }}
                    style={{ width: '100%' }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                  />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="types" label="Process" labelCol={{ span: 24 }}>
                  <Select mode="multiple" options={filterOptions.type_options} placeholder="Select Process" />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="lab_service_category_ids" label="Service Category/Test" labelCol={{ span: 24 }}>
                  <Select
                    mode="multiple"
                    options={filterOptions.lab_service_category_options}
                    placeholder="Select Category"
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    dropdownStyle={{ maxHeight: 8 * 32 }}
                    style={{ width: '100%' }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                  />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="lab_service_type" label="Service Type" labelCol={{ span: 24 }}>
                  <Select options={filterOptions.lab_service_type_options} placeholder="Select Type" />
                </Form.Item>
              </Col>
              {commonDateRange}
              <Col span={colSpan}>
                <Form.Item name="date_related_to" label="Count For" labelCol={{ span: 24 }}>
                  <Select options={filterOptions.date_related_to_option} />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="count_by" label="Count By" labelCol={{ span: 24 }}>
                  <Select options={filterOptions.lab_count_by_options} />
                </Form.Item>
              </Col>
            </Row>
            {/* {renderCheckboxRow()} */}
          </>
        );

      case 'earnings-by-divisions-nom-pay':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="division_ids" label="Division" labelCol={{ span: 24 }}>
                <Select
                  mode="multiple"
                  options={filterOptions.division_options}
                  placeholder="Select Division"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {/* <Col span={colSpan}>
              <Form.Item name="category" label="Category/Test" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_sample_options} placeholder="Select Category" />
              </Form.Item>
            </Col> */}
            <Col span={colSpan}>
              <Form.Item name="lab_service_type" label="Service Type" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_service_type_options} placeholder="Select Type" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );

      case 'sample-count-by-divisions':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="LR">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="division_ids" label="Division" labelCol={{ span: 24 }}>
                <Select
                  mode="multiple"
                  options={filterOptions.division_options}
                  placeholder="Select Division"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="types" label="Process" labelCol={{ span: 24 }}>
                <Select
                  mode="multiple"
                  options={filterOptions.type_options}
                  placeholder="Select Process"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="lab_service_type" label="Service Type" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_service_type_options} placeholder="Select Type" />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Count For" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="count_by" label="Count By" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_count_by_options} />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'item-qty-by-divisions':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="LR">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="division_ids" label="Division" labelCol={{ span: 24 }}>
                <Select
                  mode="multiple"
                  options={filterOptions.division_options}
                  placeholder="Select Division"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="types" label="Process" labelCol={{ span: 24 }}>
                <Select
                  mode="multiple"
                  options={filterOptions.type_options}
                  placeholder="Select Process"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="lab_service_type" label="Service Type" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_service_type_options} placeholder="Select Type" />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Count For" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="count_by" label="Count By" labelCol={{ span: 24 }}>
                <Select options={filterOptions.lab_count_by_options} />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'pr-earnings-by-departments':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="type" label="Type" labelCol={{ span: 24 }}>
                <Select options={filterOptions.type_options} placeholder="Select Type" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
            {commonDateRange}
            {/* <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col> */}
          </Row>
        );

      case 'pr-count-by-departments':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {/* <Col span={colSpan}>
              <Form.Item name="category_ids" label="Category/Test" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.pr_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col> */}
            <Col span={colSpan}>
              <Form.Item name="type" label="Type" labelCol={{ span: 24 }}>
                <Select options={filterOptions.type_options} placeholder="Select Type" />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'registrations-by-establishment':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="pr_category_id" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.parent_pr_category_options}
                  placeholder="Select Category"
                  // mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item
                name="year"
                label="Year"
                labelCol={{ span: 24 }}
                getValueFromEvent={(value) => (value ? parseInt(value, 10) : undefined)}
              >
                <Select
                  placeholder="Select Year"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? '').toString().includes(input)}
                  style={{ width: '100%' }}
                  options={Array.from({ length: 50 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return { value: year, label: year.toString() };
                  })}
                />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'imp-exp-earnings-by-departments':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="IMP_EXP">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Category"
                  // /mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="product_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'imp-exp-count-by-departments':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="IMP_EXP">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Type"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {/* <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.type !== currentValues.type}>
              {({ getFieldValue }) => {
                const selectedType = getFieldValue('type');

                return (
                  <>
                    {selectedType === 'IMPORT' && (
                      <Col span={colSpan}>
                        <Form.Item name="types" label="Import Process" labelCol={{ span: 24 }}>
                          <Select options={filterOptions.import_types_options} />
                        </Form.Item>
                      </Col>
                    )}
                    {selectedType === 'EXPORT' && (
                      <Col span={colSpan}>
                        <Form.Item name="types" label="Export Process" labelCol={{ span: 24 }}>
                          <Select options={filterOptions.export_types_options} />
                        </Form.Item>
                      </Col>
                    )}
                  </>
                );
              }}
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="pr_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="level" label="Level" labelCol={{ span: 24 }}>
                <Select options={filterOptions.level_options} placeholder="Select Level" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );

      case 'imp-exp-earnings-comparison':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="product_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item
                name="with_np"
                label="Include Nominal Payments?"
                labelCol={{ span: 24 }}
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'imp-exp-counts-comparison':
        return (
          <Row gutter={[16, 16]}>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="product_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item
                name="with_np"
                label="Include Nominal Payments?"
                labelCol={{ span: 24 }}
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          </Row>
        );
      case 'imp-exp-nominal-earnings':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Category"
                  // /mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_status" label="Invoice Status" labelCol={{ span: 24 }}>
                <Select options={filterOptions.invoice_status_option} />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="product_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {/* <Col span={colSpan}>
              <Form.Item
                name="with_np"
                label="Include Nominal Payments?"
                labelCol={{ span: 24 }}
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col> */}
          </Row>
        );
      case 'imp-exp-nominal-count':
        return (
          <Row gutter={[16, 16]}>
            <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item>
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Type"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );
      case 'imp-exp-levels-by-qty':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Type"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="pr_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );
      case 'consignment-by-country':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="pr_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="import_types" label="Import Process" labelCol={{ span: 24 }}>
                <Select options={filterOptions.import_types_options} mode="multiple" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="export_types" label="Export Process" labelCol={{ span: 24 }}>
                <Select options={filterOptions.export_types_options} mode="multiple" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );
      case 'imp-exp-tonnage':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Department" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="type" label="Consignment Type" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.type_options}
                  placeholder="Select Type"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="pr_category_ids" label="Category" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.product_category_options}
                  placeholder="Select Category"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {/* <Col span={colSpan}>
              <Form.Item name="import_types" label="Import Process" labelCol={{ span: 24 }}>
                <Select options={filterOptions.import_types_options} mode="multiple" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="export_types" label="Export Process" labelCol={{ span: 24 }}>
                <Select options={filterOptions.export_types_options} mode="multiple" />
              </Form.Item>
            </Col> */}
            <Col span={colSpan}>
              <Form.Item name="date_related_to" label="Date Related To" labelCol={{ span: 24 }}>
                <Select options={filterOptions.date_related_to_option} placeholder="Select Date Related To" />
              </Form.Item>
            </Col>
            {commonDateRange}
          </Row>
        );
      case 'h-form':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="invoice_generated_by" label="Invoices Generated By" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="invoice_generated_for" label="Invoices Generated For" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="payment_method" label="Payment Method" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.payment_method_options}
                  placeholder="Select Payment Method"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="cashier" label="Cashier" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.cashier_options}
                  placeholder="Select Cashier"
                  //mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="cashier_location" label="Cashier Location" labelCol={{ span: 24 }}>
                <Select options={filterOptions.cashier_location_options} placeholder="Select Cashier Location" />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'summary-report':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Departments" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_types" label="Department Types" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.department_type_options}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item name="with_md" label="Include MD?" labelCol={{ span: 24 }} valuePropName="checked">
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="with_details" label="Include Details?" labelCol={{ span: 24 }} valuePropName="checked">
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          </Row>
        );

      case 'cashier-point-summary':
        return (
          <Row gutter={[16, 16]}>
            {/* <Form.Item name="model" hidden initialValue="NP">
              <BaseInput />
            </Form.Item> */}
            <Col span={colSpan}>
              <Form.Item name="cashier_ids" label="Cashier" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.cashier_options}
                  placeholder="Select Cashier"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="cashier_location_ids" label="Cashier Location" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.cashier_location_options}
                  placeholder="Select Cashier Location"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_ids" label="Departments" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.departmentOptions}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="department_types" label="Department Types" labelCol={{ span: 24 }}>
                <Select
                  options={filterOptions.department_type_options}
                  placeholder="Select Department"
                  mode="multiple"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  dropdownStyle={{ maxHeight: 8 * 32 }}
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                />
              </Form.Item>
            </Col>
            {commonDateRange}
            <Col span={colSpan}>
              <Form.Item
                name="with_partial"
                label="Include Partial Payments?"
                labelCol={{ span: 24 }}
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
            <Col span={colSpan}>
              <Form.Item name="with_detail" label="Include Details?" labelCol={{ span: 24 }} valuePropName="checked">
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          </Row>
        );
      default:
        return null;
    }
  };

  return (
    <Form form={form} layout="vertical">
      {renderFilters()}
    </Form>
  );
};

export default ReportFilters;
